<template>
  <div
    ref="modalRoot"
    tabindex="-1"
    v-on:keyup.esc="handleCancel"
  >
    <mdb-modal v-if="visible" centered elegant>
      <mdb-modal-header :close="false">
        <mdb-modal-title class="isi-heading-blue">
          {{ isUpdate ? 'Update Review' : 'Write a new review' }}
        </mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input
          label="Project Number"
          v-model="localReview.projectNumber"
          class="mb-3"
        />
        <mdb-input
          label="Project Name"
          v-model="localReview.projectName"
          class="mb-3"
        />
        <mdb-input
          label="Review Title"
          v-model="localReview.title"
          class="mb-3"
        />
        <mdb-input
          ref="messageInput"
          type="textarea"
          label="Review Content"
          v-model="localReview.message"
          :rows="6"
          @input="handleMessageInput"
        />
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn color="secondary" @click="handleCancel">Cancel</mdb-btn>
        <mdb-btn
          color="isi"
          :disabled="!localReview.projectNumber || !localReview.projectName || !localReview.title || !localReview.message"
          @click="handleSubmit"
        >
          {{ isUpdate ? 'Update Review' : 'Submit Review' }}
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
export default {
  name: 'ReviewEditorModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    review: {
      type: Object,
      required: true
    },
    modalTitle: {
      type: String,
      default: 'Write a new review'
    }
  },
  data() {
    return {
      localReview: { ...this.review }
    };
  },
  watch: {
    visible: {
      handler(isVisible) {
        if (!isVisible) {
          return;
        }

        this.$nextTick(() => {
          this.$refs.modalRoot?.focus({ preventScroll: true });
          this.syncMessageTextareaHeight();
        });
      },
      immediate: true
    },
    review: {
      handler(newVal) {
        this.localReview = { ...newVal };
        this.$nextTick(() => {
          this.syncMessageTextareaHeight();
        });
      },
      immediate: true
    }
  },
  methods: {
    handleMessageInput() {
      this.$nextTick(() => {
        this.syncMessageTextareaHeight();
      });
    },
    syncMessageTextareaHeight() {
      const textarea = this.$refs.messageInput?.$refs?.input;

      if (!textarea) {
        return;
      }

      textarea.style.overflowY = 'hidden';
      textarea.style.resize = 'none';
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    },
    handleCancel() {
      this.$emit('cancel');
    },
    handleSubmit() {
      this.$emit('submit', { ...this.localReview });
    }
  },
  computed: {
    // determines if this is editing an existing review
    isUpdate() {
      return this.localReview.id != null && this.localReview.createdAt != null;
    }
  }
};
</script>

<style scoped>
:deep(.md-form textarea.form-control) {
  overflow-y: hidden;
  resize: none;
}
</style>
